// extracted by mini-css-extract-plugin
export default {"firstSection":"HeaderTop_firstSection__7cxDK","hide":"HeaderTop_hide__kfUHo"};